import {FC, useCallback, useState, cloneElement, useEffect} from 'react';
import {LoginModalProps} from './LoginModal';
import {useSession} from 'next-auth/react';
import dynamic from 'next/dynamic';
import {InteractionLoadable} from '@liveComponents/Loadable';
import {Spinner} from "@components/Spinner";

const LoginModal = dynamic(() => import('./LoginModal'), {ssr: false});

export type LoginRequiredActionProps = {
    children: React.ReactElement;
    initialPage?: LoginModalProps['initialPage'];
    initialPageProps?: Record<string, any>;
};

export const LoginRequiredAction: FC<LoginRequiredActionProps> = ({children, initialPage, initialPageProps}) => {
    const [isOpen, setOpen] = useState<boolean>(false);
    const {status} = useSession();

    const closeModal = useCallback(() => {
        setOpen(false);
    }, []);

    const processClick = useCallback(() => {
        if (status === 'authenticated') {
            children.props.onClick && children.props.onClick();
        } else {
            setOpen(true);
        }
    }, [status, children]);

    const processSuccess = useCallback(() => {
        closeModal();
        children.props.onClick && children.props.onClick();
    }, [closeModal, children]);

    useEffect(() => {
        if (isOpen && status === "authenticated") {
            setOpen(false);
            children.props.onClick && children.props.onClick();
        }
    }, [isOpen, status, children]);

    return (
        <>
            {cloneElement(children, Object.assign({}, children.props, {onClick: processClick}))}

            {isOpen && status === "loading" && (
                <Spinner animation={"border"} overlay fullPage />
            )}

            <InteractionLoadable show={isOpen && status !== "loading"} keepRendered>
                <LoginModal show={isOpen && status !== "loading"} onHide={closeModal} initialPage={initialPage} initialPageProps={initialPageProps} onSuccess={processSuccess} />
            </InteractionLoadable>
        </>
    );
};
